import type { AggregatedStat, TAttributionModel } from '@feathr/blackbox';

export enum EEmailStats {
  Clicks = 'clicks',
  ClicksPerPerson = 'clicksPerPerson',
  Complaints = 'complaints',
  Conversions = 'conversions',
  ConversionValue = 'conversionValue',
  Deliveries = 'deliveries',
  DeliveryRate = 'deliveryRate',
  Bounces = 'bounces',
  HardBounces = 'hardBounces',
  NotSent = 'notSent',
  NotSentViaOptOut = 'notSentViaOptOut',
  Opens = 'opens',
  OpensPerPerson = 'opensPerPerson',
  Sends = 'sends',
  SoftBounces = 'softBounces',
  Targeted = 'targeted',
  UniqueClicks = 'uniqueClicks',
  UniqueClickThroughRate = 'uniqueClickThroughRate',
  UniqueOpenRate = 'uniqueOpenRate',
  UniqueOpens = 'uniqueOpens',
  Unsubscribes = 'unsubscribes',
}

export function getEmailStats(
  stats: AggregatedStat,
  attributionModel?: TAttributionModel,
): Record<EEmailStats, number> {
  const {
    pinpoint_tracked_email_hardbounce: hardBounces = 0,
    pinpoint_tracked_email_softbounce: softBounces = 0,
    pinpoint_tracked_email_complaint: complaints = 0,
    email_not_sent_via_opt_out: notSentViaOptOut = 0,
  } = stats.get('flavors', {});

  const emailStats = {
    clicks: stats.get('num_clicks', 0),
    clicksPerPerson: stats.get('clicks_per_person', 0),
    complaints,
    deliveries: stats.get('num_deliveries_email', 0),
    deliveryRate: stats.get('successful_delivery_rate', 0),
    bounces: hardBounces + softBounces,
    hardBounces,
    opens: stats.get('num_views', 0),
    opensPerPerson: stats.get('opens_per_person', 0),
    sends: stats.get('num_sends_email', 0),
    softBounces,
    targeted: stats.get('num_targeted', 0),
    notSent: stats.get('num_not_sent', 0),
    notSentViaOptOut,
    uniqueClicks: stats.get('num_clicks_active', 0),
    uniqueClickThroughRate: stats.get('email_click_through_rate', 0),
    uniqueOpenRate: stats.get('email_open_rate', 0),
    uniqueOpens: stats.get('num_users_active', 0),
    unsubscribes: stats.get('num_persons_unsubscribed', 0),
  } as Record<EEmailStats, number>;

  if (attributionModel) {
    emailStats.conversions = stats.get('conversions')?.[attributionModel]?.num || 0;
    emailStats.conversionValue = stats.get('conversions')?.[attributionModel]?.roi || 0;
  }

  return emailStats;
}
